enum UserPermissions {
  userTeamManagement = "user-team-management",
  debugTools = "debug-tools",
  ignoreWhenTracking = "ignore-when-tracking"
}

export default UserPermissions;
